export function getLabelItem(item) {
  const returnLabel = {
    title: "Нормальное",
    style: "default"
  };

  if (item._new) {
    returnLabel.title = "Новое";
    returnLabel.style = "warning";
    return returnLabel;
  }

  if (item.lom) {
    returnLabel.title = "Лом";
    returnLabel.style = "error";
  }

  return returnLabel;
}

export function getPriceItem(item) {
  if (item._new) {
    return item.prices.price_new;
  }

  if (item.lom) {
    return item.prices.price_crack;
  }

  return item.prices.price_normal;
}
